export const formatRows = (listaItems, tipooferta) =>
  listaItems.map((item) => {
    let desc= item["oferta_Art"]?.art_descripcion;
    return {
      id: item.id,
      art_descripcion: desc, // Verifica si oferta_Art existe
      aofd_art_nprecio: item.aofd_art_nprecio,
      aofd_ofertaprecio: item.aofd_ofertaprecio,
      ...(Number(tipooferta) === 1 ? { aofd_ofertastock: item.aofd_ofertastock } : {}),
    };
  });
